(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initialize = (root = document) => {
    root.querySelectorAll('.noomi-about__media:not([data-interactions-ready])').forEach((media) => {
      media.dataset.interactionsReady = 'true';

      const section = media.closest('.noomi-about');
      let frame = 0;
      let pointerX = 0;
      let pointerY = 0;

      const renderPointer = () => {
        media.style.setProperty('--noomi-field-x', pointerX.toFixed(3));
        media.style.setProperty('--noomi-field-y', pointerY.toFixed(3));
        frame = 0;
      };

      const resetPointer = () => {
        if (frame) window.cancelAnimationFrame(frame);
        frame = 0;
        pointerX = 0;
        pointerY = 0;
        media.style.setProperty('--noomi-field-x', '0');
        media.style.setProperty('--noomi-field-y', '0');
        delete media.dataset.interacting;
      };

      media.addEventListener(
        'pointermove',
        (event) => {
          if (reducedMotion.matches || event.pointerType === 'touch') return;

          const bounds = media.getBoundingClientRect();
          pointerX = ((event.clientX - bounds.left) / bounds.width - 0.5) * 2;
          pointerY = ((event.clientY - bounds.top) / bounds.height - 0.5) * 2;
          media.dataset.interacting = 'true';

          if (!frame) frame = window.requestAnimationFrame(renderPointer);
        },
        { passive: true }
      );

      media.addEventListener('pointerleave', resetPointer, { passive: true });

      if ('IntersectionObserver' in window && section) {
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting && !reducedMotion.matches) {
              media.dataset.inView = 'true';
            } else {
              delete media.dataset.inView;
              resetPointer();
            }
          },
          { rootMargin: '80px 0px', threshold: 0.08 }
        );

        observer.observe(section);
      } else if (!reducedMotion.matches) {
        media.dataset.inView = 'true';
      }
    });
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
